import { useQueryClient } from '@tanstack/react-query';
import { useMemo } from 'react';
import { ActionLogItemResult, Profile, SimpleUser, getRepositoryQueryKey } from '@mews-commander/data-access';
import { compactArray, keyBy } from '@mews/fp';

export interface ActionLogData {
    users: { [userId: string]: SimpleUser | undefined };
    profiles: { [profileId: string]: Profile | undefined };
}

/**
 * Reads the data from react-query fetched in fetchActionLogItems and combines all the loaded profiles and users.
 * With the current pagination, it's impossible to use the queries directly in the components.
 */
export const useActionLogData = () => {
    const queryClient = useQueryClient();

    const data = queryClient.getQueriesData<ActionLogItemResult>({
        queryKey: getRepositoryQueryKey('actionLogItems', 'getAll'),
        exact: false,
    });

    return useMemo<ActionLogData>(
        () => ({
            users: keyBy('id', compactArray(data.flatMap(([, item]) => item?.users))),
            profiles: keyBy('id', compactArray(data.flatMap(([, item]) => item?.profiles))),
        }),
        [data]
    );
};
